import { type SelectLocationAction } from './selectLocation.action';
import {
  FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING,
  FRONTEND_STATE_SELECT_LOCATION_START,
  FRONTEND_STATE_SELECT_LOCATION_STOP,
} from './selectLocation.actionTypes';
import { type SelectLocationState } from './selectLocation.state';

const initialState: SelectLocationState = {
  active: false,
};

export const selectLocationReducer = (state = initialState, action: SelectLocationAction): SelectLocationState => {
  switch (action.type) {

    case FRONTEND_STATE_SELECT_LOCATION_START: {
      return {
        ...state,
        active: true,
        configuration: action.payload.configuration,
      };
    }

    case FRONTEND_STATE_SELECT_LOCATION_STOP: {
      return {
        ...state,
        active: false,
      };
    }

    case FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING: {
      return {
        ...state,
        isAddressLookupLoading: action.payload.isLoading,
      };
    }

    default: {
      return state;
    }
  }
};
